var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrivalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 10,
    viewBox: "0 0 49 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0495 0.404103C43.7149 0.117284 43.2111 0.156036 42.9243 0.490658C42.6375 0.825281 42.6762 1.32906 43.0108 1.61588L46.224 4.36999H1.63473C1.26746 4.36999 0.969727 4.66772 0.969727 5.03499C0.969727 5.40226 1.26746 5.69999 1.63473 5.69999H46.1423L43.0108 8.3841C42.6762 8.67092 42.6375 9.1747 42.9243 9.50932C43.2111 9.84394 43.7149 9.8827 44.0495 9.59588L48.7045 5.60588C48.8814 5.45427 48.9832 5.23295 48.9832 4.99999C48.9832 4.76703 48.8814 4.54571 48.7045 4.3941L44.0495 0.404103Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivalIcon);
export default __webpack_public_path__ + "static/media/ArrivalIcon.83e30a670dc71f3404667b7875d7e0b3.svg";
export { ForwardRef as ReactComponent };